import h from 'stringjsx';
import I18n from '@/modules/i18n';
import {axios} from '@/modules/request/axios_configuration';

export function mount(
  target: HTMLDivElement,
  documentType: string,
  documentId: number,
  commentThreadId: number | null,
) {
  let discrepancyId: number | null = null;
  let actionLog = ``;

  const selectedDiscrepancies = {
    missing_sale_date: false,
    missing_seller_name_or_orgno: false,
    missing_seller_vat_registered: false,
    missing_buyer_name_or_address_or_orgno: false,
    missing_delivery_time_or_place: false,
    missing_price_with_vat: false,
    missing_total_price: false,
    missing_remuneration: false,
    missing_payment_deadline: false,
    missing_product_or_service_description: false,
  };

  target.innerHTML = <div class="loader">{ I18n.t(`loading`) }</div>;
  fetchData();

  const discrepancyKeys = () =>
    Object.keys(selectedDiscrepancies) as Array<keyof typeof selectedDiscrepancies>;

  type DiscrepancyJSON = typeof selectedDiscrepancies & {
    id: number;
    action_log: string;
  };

  function save() {
    axios({
      method: `POST`,
      url: `/comment_threads/${documentType}/${documentId}/sale_document_discrepancies`,
      data: {
        sale_document_discrepancy: selectedDiscrepancies
      },
      success: ({data}: {data: DiscrepancyJSON}) => {
        discrepancyId = data.id;
        actionLog = data.action_log;

        renderAndBindEvents();
        alertify.success(I18n.t(`success`));
      },
    });
  }

  function fetchData() {
    axios({
      method: `GET`,
      url: `/comment_threads/${documentType}/${documentId}/sale_document_discrepancies`,
      success: ({data}: {data: null | DiscrepancyJSON}) => {
        if (data) {
          discrepancyId = data.id;
          actionLog = data.action_log;
          discrepancyKeys()
            .forEach(key => selectedDiscrepancies[key] = data[key]);
        }

        renderAndBindEvents();
      },
    });
  }

  function renderAndBindEvents() {
    target.innerHTML = render();
    target.querySelector(`[js-save]`)!.addEventListener(`click`, save);

    discrepancyKeys().forEach(key => {
      target
        .querySelector(`[name=${key}]`)!
        .addEventListener(
          `change`,
          e => selectedDiscrepancies[key] = (e.currentTarget as HTMLInputElement).checked
        );
    });
  }

  function render() {
    const discrepancySaved = !!discrepancyId;
    const helpUrl = {
      en: `https://info.altinn.no/en/start-and-run-business/accounts-and-auditing/accounting/invoices-sales-documentation/`,
      nb: `https://info.altinn.no/starte-og-drive/regnskap-og-revisjon/regnskap/faktura-salgsdokumentasjon/`,
    }[I18n.locale as `en` | `nb`];
    const isChecked = discrepancyKeys().some(key => selectedDiscrepancies[key]);

    return <div class="m-b-4">
      <details open={discrepancySaved || !commentThreadId || isChecked}>
        <summary style="font-size:1.75rem">
          {I18n.t(`comment_threads.sale_document_discrepancies.select_missing_fields`)}
        </summary>

        <p>{I18n.t(`comment_threads.sale_document_discrepancies.info`)}</p>
        <p>
          {I18n.t(`comment_threads.sale_document_discrepancies.more_info`)}:<br/>
          <a href={helpUrl} target="_blank">{helpUrl}</a>
        </p>

        <div>
          {
            discrepancyKeys().map(key => {
              const isChecked = selectedDiscrepancies[key];
              return (
                <div>
                  <label>
                    <input
                      type="checkbox"
                      name={key}
                      value={key}
                      class="js-comment-thread-checkbox m-r-1"
                      checked={isChecked}
                      disabled={discrepancySaved}
                    />
                    {I18n.t(`comment_threads.sale_document_discrepancies.${key}`)}
                  </label>
                </div>
              );
            })
          }
        </div>

        <button class="buttons-standard" js-save disabled={discrepancySaved}>{I18n.t(`save`)}</button>
        <span dangerouslySetInnerHTML={{__html: actionLog}}/>
      </details>
    </div>;
  }
}
